"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connect = exports.configure = void 0;
var tslib_1 = require("tslib");
var binding = tslib_1.__importStar(require("./binding"));
var connector = tslib_1.__importStar(require("./connector"));
var error = tslib_1.__importStar(require("./error"));
var message = tslib_1.__importStar(require("./message"));
var util = tslib_1.__importStar(require("./util"));
var caching = tslib_1.__importStar(require("./caching"));
var query = tslib_1.__importStar(require("./query"));
var partialupdate = tslib_1.__importStar(require("./partialupdate"));
var intersection = tslib_1.__importStar(require("./intersection"));
var metamodel = tslib_1.__importStar(require("./metamodel"));
var intersection_1 = require("./intersection");
var metamodel_1 = require("./metamodel");
var EntityManagerFactory_1 = require("./EntityManagerFactory");
var EntityManager_1 = require("./EntityManager");
var Acl_1 = require("./Acl");
var baqend_1 = require("./baqend");
var util_1 = require("./util");
function deprecateExports(target, targetName, newImportSignature, exports) {
    Object.keys(exports).forEach(function (exported) {
        var decorate = (0, util_1.deprecated)(newImportSignature.replace('$export', exported));
        Object.defineProperty(target, exported, decorate(targetName, exported, {
            get: function () {
                return exports[exported];
            },
        }));
    });
}
deprecateExports(util, 'util', 'intersection.$export', {
    Permission: intersection_1.Permission,
    Metadata: intersection_1.Metadata,
    TokenStorage: intersection_1.TokenStorage,
    Validator: intersection_1.Validator,
    PushMessage: intersection_1.PushMessage,
    Code: intersection_1.Code,
    Modules: intersection_1.Modules,
    Logger: intersection_1.Logger,
});
deprecateExports(EntityManager_1.EntityManager.prototype, 'db', 'import { $export } from \'baqend\'', {
    db: baqend_1.db,
    binding: binding,
    connector: connector,
    error: error,
    message: message,
    util: util,
    caching: caching,
    query: query,
    partialupdate: partialupdate,
    intersection: intersection,
    EntityManagerFactory: EntityManagerFactory_1.EntityManagerFactory,
    EntityManager: EntityManager_1.EntityManager,
    Acl: Acl_1.Acl,
});
deprecateExports(metamodel_1.Metamodel.prototype, 'metamodel', 'import { metamodel } from \'baqend\';', metamodel);
function configure() {
    throw new Error('Please use Baqend.db.configure() or import { db } from \'baqend\' instead.');
}
exports.configure = configure;
function connect() {
    throw new Error('Please use Baqend.db.connect() or import { db } from \'baqend\' instead.');
}
exports.connect = connect;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVwZXJlY2F0ZWQtZXhwb3J0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImRlcGVyZWNhdGVkLWV4cG9ydHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHlEQUFxQztBQUNyQyw2REFBeUM7QUFDekMscURBQWlDO0FBQ2pDLHlEQUFxQztBQUNyQyxtREFBK0I7QUFDL0IseURBQXFDO0FBQ3JDLHFEQUFpQztBQUNqQyxxRUFBaUQ7QUFDakQsbUVBQStDO0FBQy9DLDZEQUF5QztBQUV6QywrQ0FFd0I7QUFDeEIseUNBQXdDO0FBQ3hDLCtEQUE4RDtBQUM5RCxpREFBZ0Q7QUFDaEQsNkJBQTRCO0FBRTVCLG1DQUE4QjtBQUM5QiwrQkFBb0M7QUFFcEMsU0FBUyxnQkFBZ0IsQ0FBQyxNQUFjLEVBQUUsVUFBa0IsRUFBRSxrQkFBMEIsRUFBRSxPQUV6RjtJQUNDLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsT0FBTyxDQUFDLFVBQUMsUUFBUTtRQUNwQyxJQUFNLFFBQVEsR0FBRyxJQUFBLGlCQUFVLEVBQUMsa0JBQWtCLENBQUMsT0FBTyxDQUFDLFNBQVMsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDO1FBQzdFLE1BQU0sQ0FBQyxjQUFjLENBQUMsTUFBTSxFQUFFLFFBQVEsRUFBRSxRQUFRLENBQUMsVUFBVSxFQUFFLFFBQVEsRUFBRTtZQUNyRSxHQUFHO2dCQUNELE9BQVEsT0FBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDO1lBQ3BDLENBQUM7U0FDRixDQUFDLENBQUMsQ0FBQztJQUNOLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQztBQUVELGdCQUFnQixDQUFDLElBQUksRUFBRSxNQUFNLEVBQUUsc0JBQXNCLEVBQUU7SUFDckQsVUFBVSwyQkFBQTtJQUFFLFFBQVEseUJBQUE7SUFBRSxZQUFZLDZCQUFBO0lBQUUsU0FBUywwQkFBQTtJQUFFLFdBQVcsNEJBQUE7SUFBRSxJQUFJLHFCQUFBO0lBQUUsT0FBTyx3QkFBQTtJQUFFLE1BQU0sdUJBQUE7Q0FDbEYsQ0FBQyxDQUFDO0FBRUgsZ0JBQWdCLENBQUMsNkJBQWEsQ0FBQyxTQUFTLEVBQUUsSUFBSSxFQUFFLG9DQUFvQyxFQUFFO0lBQ3BGLEVBQUUsYUFBQTtJQUNGLE9BQU8sU0FBQTtJQUNQLFNBQVMsV0FBQTtJQUNULEtBQUssT0FBQTtJQUNMLE9BQU8sU0FBQTtJQUNQLElBQUksTUFBQTtJQUNKLE9BQU8sU0FBQTtJQUNQLEtBQUssT0FBQTtJQUNMLGFBQWEsZUFBQTtJQUNiLFlBQVksY0FBQTtJQUVaLG9CQUFvQiw2Q0FBQTtJQUNwQixhQUFhLCtCQUFBO0lBQ2IsR0FBRyxXQUFBO0NBQ0osQ0FBQyxDQUFDO0FBRUgsZ0JBQWdCLENBQUMscUJBQVMsQ0FBQyxTQUFTLEVBQUUsV0FBVyxFQUFFLHVDQUF1QyxFQUFFLFNBQVMsQ0FBQyxDQUFDO0FBRXZHLFNBQWdCLFNBQVM7SUFDdkIsTUFBTSxJQUFJLEtBQUssQ0FBQyw0RUFBNEUsQ0FBQyxDQUFDO0FBQ2hHLENBQUM7QUFGRCw4QkFFQztBQUVELFNBQWdCLE9BQU87SUFDckIsTUFBTSxJQUFJLEtBQUssQ0FBQywwRUFBMEUsQ0FBQyxDQUFDO0FBQzlGLENBQUM7QUFGRCwwQkFFQyJ9